// The control tab „Belege“ (ADR-0085 FR-56): the display switch. State and
// figures are rendered by the server, so a switch reloads the page, as on
// the tab „Teilen“.

import { axios } from './vendor.js';

export function initControlChecks() {
    const root = document.getElementById('controlChecks');
    document.getElementById('checksSwitchConfirm').addEventListener('click', async () => {
        const active = root.dataset.targetActive === 'true';
        await axios.post(root.dataset.switchUrl, { active });
        window.location.reload();
    });
}
